import Zip2adr from '@/js/components/zip2adr'
import Modal from '@/js/components/modal'
import ikkyuPlanGuideHtml from '@/html/ikkyu-plan-guide.html'
import inputCommon from './_input_common';

export const inputBasicAction = () => {
    inputCommon();
    const modal = new Modal()
    const setStationAction = () => {
        let stationList = {}
        const addValue = data => {
            // 重複チェック
            if (!data) return
            if ($(`.stations div[data-key="${data.key}"]`).length) {
                return false
            }
            let values = $('input[name=station]').val() ? $('input[name=station]').val().split(',') : []
            values.push(data.key)
            $('input[name=station]').val(values.join(','))

            let template = $('.station .template > div').clone(true)
            template.attr('data-key', data.key).find('.name').text(`${data.name.station} / ${data.name.line}`)

            $('.stations').append(template)
        }

        const delValue = obj => {
            obj.remove()
            let keyList = []
            $('.stations > div').each((_idx, _obj) => {
                keyList.push($(_obj).attr('data-key'))
            })
            $('input[name=station]').val(keyList.join(','))
        }

        const setDelAction = obj => {
            obj.find('.del').on('click', e => {
                delValue($(e.currentTarget).parent())
            })
        }
        setDelAction($('.station .template > div'))
        setDelAction($('.stations > div'))

        const createModal = values => {
            const base = $('#station-modal').clone().removeClass('template').attr('id', null)
            const liTmpl = base.find('li').clone()
            const ul = base.find('ul')
            ul.empty()

            values.forEach(_val => {
                stationList[_val.key] = _val
                let li = liTmpl.clone()
                li
                    .find('input').val(_val.key)
                    .end()
                    .find('.name').text(`${_val.name.station} / ${_val.name.line}`)
                ul.append(li)
            })

            return base.get(0).outerHTML
        }

        const stationSearch = () => {
            let name = $('.station-input').val()
            if (!name) {
                return false
            }
            $.ajax({
                url: '/entry/api/station',
                type: 'get',
                data: {
                    name,
                },
                dataType: 'json',
            })
                .done(resp => {
                    let cnt = resp.data.length
                    switch (cnt) {
                        case 0:
                            alert('該当する駅はありません。')
                            break
                        case 1:
                            addValue(resp.data[0])
                            break
                        default:
                            modal.setHtml(createModal(resp.data))
                            modal.show()
                            modal.settings.createDom.find('button').on('click', e => {
                                $(e.currentTarget).prev('ul').find('input[type=checkbox]:checked').each((_idx, _obj) => {
                                    let key = $(_obj).val()
                                    addValue(stationList[key])
                                })
                                modal.close()
                                return false
                            })
                    }
                })
        }

        const userAgent = window.navigator.userAgent.toLowerCase()
        if (userAgent.indexOf('trident') != -1) {
            $('.station-input').next('button').on('click', () => {
                stationSearch()
                return false
            })
        } else {
            $('#station-search').submit(e => {
                stationSearch()
                return false
            })
        }
    }

    setStationAction()

    $('.ikkyu-plan-guide-modal').on('click', () => {
        modal.setHtml(ikkyuPlanGuideHtml)
        modal.show()
    })

    // 住所の自動入力
    const zip2adr = new Zip2adr();
    $('button.button-autofill').click(function () {

        const zipCode = $('input[name="postcode"]').val()
        if (!zipCode) return false;
        if ($('input[name="address"]').val()) {
            if (!window.confirm("現在入力されている住所が更新されます。よろしいですか？")) {
                return false
            }
        }
        zip2adr.check(zipCode)
            .then(resp => {
                console.log(resp)
                if (resp.result) {
                    $('select[name="prefecture"]').val(resp.prefNo)
                    $('input[name="address_after"]').val(resp.below)
                } else {
                    alert("入力いただいた郵便番号の地域は存在しません。")
                }
            })
        return false;
    });

    $('.time-select').find('select').on('change', e => {
        let params = []
        let chk = true
        let setValue = ''
        let parentObj = $(e.currentTarget).closest('.time-select')
        parentObj.find('select').each((_key, _val) => {
            let value = $(_val).val()
            if (!value) {
                chk = false
            }
            params.push(value)
        })
        if (chk) {
            switch (params.length) {
                case 2:
                    setValue = `${params[0]}:${params[1]}`
                    break
                case 4:
                    setValue = `${params[0]}:${params[1]}-${params[2]}:${params[3]}`
            }
        }
        parentObj
            .find('.input-check-container input[type=hidden]')
            .val(setValue)
    })

    $('.time-select').each((key, obj) => {
        let value = $(obj).find('.input-check-container input[type=hidden]').val()
        let values = value.match(/([0-9]+)/g)
        if (values) {
            values.forEach((_val, key) => {
                $(obj).find('select').eq(key).val(_val)
            })
        }
    })

    $('.field-holiday').find('input[type="checkbox"]').eq(0).on('change', e => {
        if ($(e.currentTarget).prop('checked')) {
            $('.field-holiday').find('input[type="checkbox"]').slice(1, -1).prop('checked', false)
        }
    })
    $('.field-holiday').find('input[type="checkbox"]').slice(1, -1).on('change', e => {
        if ($(e.currentTarget).prop('checked')) {
            $('.field-holiday').find('input[type="checkbox"]').eq(0).prop('checked', false)
        }
    })

    // チェックの自動入力
    $('input[name="holiday_other"]').on('keyup', () => {
        $('input[name="holiday[]"]').last().prop('checked', true)
    })

    // 内容が入力されたときはチェックは外せない
    $('input[name="holiday[]"]').last().on('change', e => {
        if ($(e.currentTarget).prop('checked') == false) {
            if ($('input[name="holiday_other"]').val()) {
                $(e.currentTarget).prop('checked', true)
            }
        }
    })

    if (!$('input[name="creditcard_type[]"').eq(0).prop('checked')) {
        $('input[name="creditcard_type[]"').eq(5).prop('checked', true)
    }
    $('input[name="creditcard_type[]"],input[name="takeout_creditcard_type[]"]').on('change', e => {
        let val = $(e.currentTarget).val()
        let name = $(e.currentTarget).attr('name')
        let chkObjs = $(`input[name="${name}"`)
        switch (val) {
            case "1":
                chkObjs.eq(5).prop('checked', !$(e.currentTarget).prop('checked'))
                break
            case "6":
                chkObjs.eq(0).prop('checked', !$(e.currentTarget).prop('checked'))
                break
            default:
        }
        if (name == "takeout_creditcard_type[]") {
            switch (val) {
                case "7":
                    chkObjs.slice(0, -1).prop('checked', false)
                    break
                default:
                    chkObjs.eq(6).prop('checked', false)
            }
        }
    })

    // オンライン予約利用(online_resv)の選択によるtakeout_ikyu_flgの表示制御
    $('input[name="online_resv"]').on('change', e => {
        let val = $(e.currentTarget).val()
        switch (val) {
            case "0":
                $('.item-takeout-ikyu-flg').removeClass('show')
                break
            default:
                $('.item-takeout-ikyu-flg').addClass('show')
                break
        }
    })
    $('input[name="online_resv"]:checked').trigger('change')
}

const main = () => {
    if (!document.querySelector('#page-entry-input-basic')) return false;
    inputBasicAction();
}
export default main;